import { RootState } from '@store';
import { useSelector } from 'react-redux';

export const useGetUser = () => useSelector((state: RootState) => state.general.user);
export const useGetJwt = () => useSelector((state: RootState) => state.general.jwt);
export const useGetLoading = () => useSelector((state: RootState) => state.general.isLoading);
